"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M11.162 18.87c-3.683-3-3.683-9.324 0-12.324a1.2 1.2 0 0 0-1.516-1.86c-4.861 3.96-4.861 12.084 0 16.044a1.2 1.2 0 0 0 1.516-1.86Zm7.547-6.621a1.2 1.2 0 1 1-2.219.918 1.2 1.2 0 0 1 2.219-.918Z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M13.637 12.708a4.325 4.325 0 0 1 1.223-3.035 1.199 1.199 0 0 0-1.312-1.95 1.2 1.2 0 0 0-.4.256 6.72 6.72 0 0 0-1.91 4.73 6.718 6.718 0 0 0 1.91 4.728 1.2 1.2 0 0 0 2.056-.847 1.2 1.2 0 0 0-.344-.847 4.325 4.325 0 0 1-1.223-3.035Z"
  })]
});